import type { IntlShape } from "react-intl";

export default function translateServerErrorIntoFriendlyMessage(
  error: unknown,
  intl: IntlShape,
  defaultMessage?: string,
) {
  if (!(error instanceof Error)) {
    return (
      defaultMessage ??
      intl.formatMessage({
        defaultMessage: "Falha técnica. Não foi possível executar a operação, entre em contato no suporte!",
        id: "rlRdvY",
      })
    );
  }

  if (/Comment not found/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Comentário não encontrado",
      id: "StpP5z",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/Comment is already locked/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Este comentário já está trancado",
      id: "3qGUPQ",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/Comment is already unlocked/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Este comentário já está destrancado",
      id: "tWr7Kq",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/Only Premium users are allowed to comment/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Apenas usuários Premium podem enviar comentários.",
      id: "OeDcQI",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (
    /You're not allowed to post a comment with less than 3 characters/i.test(error.message) ||
    /Comment is too short/i.test(error.message)
  ) {
    return intl.formatMessage({
      defaultMessage: "Seu comentário deve ter no mínimo 3 caracteres.",
      id: "DFPykH",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (
    /You're not allowed to post a comment with more than ([\d+]) characters/i.test(error.message) ||
    /Comment is too long/i.test(error.message)
  ) {
    return intl.formatMessage({
      defaultMessage: "Seu comentário é muito grande. Por favor, tente novamente com um comentário menor.",
      id: "te0iLr",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/Couldn't post the comment/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Não foi possível publicar seu comentário.",
      id: "cabb2m",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/You're not authorized/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage:
        "Não foi possível publicar seu comentário por que sua sessão expirou. Por favor, faça o login novamente.",
      id: "+3yK3o",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/The provided password doesn't match/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "A senha atual não confere. Verifique os dados e tente novamente.",
      id: "lXjkiP",
      description: "Possíveis erros ao submeter um formulário",
    });
  }

  if (/You're already using this email/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Você já está usando esse email.",
      description: "Possíveis erros ao submeter um formulário",
      id: "3AK3Ce",
    });
  }

  if (/There's already a User with email/i.test(error.message)) {
    return intl.formatMessage({
      defaultMessage: "Esse email já está em uso.",
      description: "Possíveis erros ao submeter um formulário",
      id: "UY0yHN",
    });
  }

  return intl.formatMessage({
    defaultMessage: "Whoopz...deu algum problema aqui no servidor. Tente novamente mais tarde :(",
    id: "58MCIn",
    description: "Possíveis erros ao submeter um formulário",
  });
}
